import { mapGetters } from 'vuex'
export default {
  name: 'UserProfile',
  components: {},
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted () {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/UserProfile/component.js